import { DateTime } from "luxon"
import { useEffect, useState } from 'react'
import { apiFetchBody } from '../../utility/fetch'
import { useLoading } from '../../loading/LoadingContext'

const useAmazonPageSpeedViewsRollingData = (userData) => {
  const {toggleLoading} = useLoading()
  const now = DateTime.local().toUTC().toFormat('yyyy-MM-dd')
  const last30days = DateTime.fromISO(now).minus({days: 30}).toFormat('yyyy-MM-dd')

  const [rollingError, setRollingError] = useState(undefined)
  const [rollingData, setRollingData] = useState(undefined)
  const [refetchRolling, setRefetchRolling] = useState(undefined)

  useEffect(() => {
    const load = async () => {
      toggleLoading(true)
      try {
        const body = await apiFetchBody({
          endpoint: 'amazonPageSpeedViews',
          method: 'GET',
          accessToken: userData.accessToken,
          params: [{key: 'startDate', value: last30days}, {key: 'endDate', value: now}]
        })
        setRollingData(body)
      }catch(error){
        setRollingError(error)
      } finally {
        toggleLoading(false)
      }
    }
    load()
  }, [last30days, now, refetchRolling, userData])

  return {
    rollingError,
    rollingData,
    refetchRolling
  }
}

export default useAmazonPageSpeedViewsRollingData